import { Box } from "@mui/material";
import { ColorResult, CustomPicker } from "react-color";
import { Hue } from "react-color/lib/components/common";

import { HueSliderPointer } from "./HueSliderPointer/HueSliderPointer";

export const HueSlider = CustomPicker<object>(({ onChange, ...colorProps }) => {
  const handleChange = (color: ColorResult) => onChange?.(color);

  return (
    <Box sx={{ position: "relative", height: 16, "& .hue-horizontal": { borderRadius: 999 } }} data-test="hue-slider">
      <Hue {...colorProps} onChange={handleChange} pointer={HueSliderPointer} />
    </Box>
  );
});
